module.exports = new __parcel__URL__("sorted-indicator-asc.99c81f7a.svg").toString();